import DocumentCheck from './document-check';

export default DocumentCheck;
